import React from 'react';

const stats = [
  { value: '2',    label: 'Standorte' },
  { value: '4',    label: 'Bundesländer' },
  { value: '10+',  label: 'Jahre Erfahrung' },
];

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="hero">
      {/* Hintergrundfoto - Unsplash (kann lokal ersetzt werden) */}
      <img
        className="hero__bg"
        src="/images/hero-bg.png"
        alt=""
        aria-hidden="true"
      />
      <div className="hero__overlay" />

      <div className="hero__content container">

        <div className="hero__eyebrow">
          <span className="hero__dot" />
          Hamburg &amp; Bremen – Zwei Standorte, eine Qualität
        </div>

        <h1 className="hero__title">
          Ihr Haus in<br />
          <em>besten Händen.</em>
        </h1>

        <p className="hero__subtitle">
          Energetische Sanierung, Haussanierung und Beratung aus einer Hand –
          von der Planung bis zur schlüsselfertigen Umsetzung.
        </p>

        <div className="hero__actions">
          <button className="btn btn-primary" onClick={() => scrollTo('kontakt')}>
            Kostenlos beraten lassen
          </button>
          <button className="btn btn-ghost" onClick={() => scrollTo('leistungen')}>
            Leistungen entdecken
          </button>
        </div>

        <div className="hero__stats">
          {stats.map((s, i) => (
            <React.Fragment key={s.label}>
              {i > 0 && <div className="hero__stat-div" />}
              <div className="hero__stat">
                <span className="hero__stat-value">{s.value}</span>
                <span className="hero__stat-label">{s.label}</span>
              </div>
            </React.Fragment>
          ))}
        </div>

      </div>
    </section>
  );
}
